import React, { useState } from "react";
import { Button } from "react-bootstrap";
import UploadAsBuiltModal from "../TicketDetails/components/UploadAsBuiltModal";

const UploadAsBuilt = () => {
  const [uploadAsBuiltModalShow, setUploadAsBuiltModalShow] = useState(false);

  return (
    <div>
      <Button
        className="btn btn-primary m-3"
        onClick={() => setUploadAsBuiltModalShow(true)}
      >
        Upload AsBuilt
      </Button>
      <Button
        className="btn btn-primary"
        onClick={() => window.open("/dashboard/gsi-map", "_blank")}
      >
        Open GSI Map
      </Button>
      <UploadAsBuiltModal
        show={uploadAsBuiltModalShow}
        onHide={() => setUploadAsBuiltModalShow(false)}
        ticketInfo={null}
      />
    </div>
  );
};

export default UploadAsBuilt;
